import { render, staticRenderFns } from "./order-recurrence.vue?vue&type=template&id=4daff88a&"
import script from "./order-recurrence.vue?vue&type=script&lang=js&"
export * from "./order-recurrence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports